import { useEffect, useState } from 'react';

/**
 *
 * @param value The most up-to-date value to be debounced
 * @param delay The delay in milliseconds to wait before updating value
 */
export function useDebounce<T>(value: T, delay: number) {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
        const handler = window.setTimeout(() => {
            setDebouncedValue(value);
        }, delay);

        return () => {
            window.clearTimeout(handler);
        };
    }, [value, delay]);
    return debouncedValue;
}
